    <div class="drop-shadow-1 document-card">
        <div class="padding-1 clip4 primary-gradient-bg-100 rounded-1 h-100">
            <div class="clip4 flip-card-front overflow-hidden rounded-1 h-100">
                <div class="user-card p-2 d-flex flex-column rounded-1 content-card h-100">
                        <div class="padding-1 clip5 primary-gradient-bg-100 rounded-1 img-box">
                            <div class="clip5 flip-card-front overflow-hidden rounded-1">
                                <div class="user-card p-2 d-flex flex-column rounded-1 img-container">
                                    <ng-content select="[card-content]"></ng-content>
                                </div>
                            </div>
                        </div>

                        <div class="mt-2 text-center">
                            <ng-content select="[card-footer]"></ng-content>
                        </div>
                </div>
            </div>
        </div>
    </div>

